import { Component, ElementRef, EventEmitter, HostBinding, Input, NgZone, OnInit, Output, SimpleChange, } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { DeviceDetectorService } from 'ngx-device-detector';
import { GurdServiceService } from 'src/app/Service/gurd-service.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { OtherService } from 'src/app/Service/other.service';
import { StateManagementMenucarService } from 'src/app/Service/state-management-menucar.service';
import axios from 'src/app/Service/axios';
import * as XLSX from 'xlsx';
import { IAlarm, ILocationChanged } from 'src/app/shared/models/signalR-model';
import { SignalrService } from 'src/app/Service/signalr.service';
import { Subject, takeUntil } from 'rxjs';
declare let $: any;

@Component({
  selector: 'menu_car',
  templateUrl: './menu_carcomponent.html',
})

export class MenuCarComponent implements OnInit {
  @HostBinding('class') classes = 'Menucar';

  comapnyName: any = '';
  carNumber: number = 0;
  fullName: any = '';
  acssess: any;
  fileName = 'لیست خودرو ها.xlsx';
  filterItem: any;
  onlineCar: any = [];
  oflineCar: any = [];
  noRecord: any = [];
  isDesktop: any;
  isMobile: any;
  groupCar: any;
  filterList: any = null;
  carId: number = 0;
  analysisId: any;
  carGroupModel: string = '-1';
  bOfficial!: boolean;
  @Input() item: any;
  @Input() GeoFence: any;
  @Input() dataPolygans: any;
  @Input() dataWorkAz: any;
  @Input() dataWorkTa: any;
  @Output() locationTable = new EventEmitter<any>();
  @Output() carIdOut = new EventEmitter<any>();
  @Output() carGroup = new EventEmitter<any>();

  datasabt: FormGroup = this.formBuilder.group({

    date: new Date().valueOf(),

  });

  private destroy$ = new Subject<void>();
  private carIndexMap = new window.Map(); // strUnitID
  private hubHandlersBound = false;
  private readonly MAX_ALARMS = 100;
  public alarms: IAlarm[] = new Array(this.MAX_ALARMS);
  private alarmIndex = 0;
  private alarmCount = 0;
  isAlarmFeed: boolean = false;
  isHubConnect: boolean = false;

  constructor(

    private notifyService: NotificationService,

    private router: Router,

    public otherService: OtherService,

    private el: ElementRef,

    private deviceService: DeviceDetectorService,

    private formBuilder: FormBuilder,

    private stateManagement: StateManagementMenucarService,

    private gurdService: GurdServiceService,

    private _signalRService: SignalrService,

    private ngZone: NgZone,


  ) {

    this.isDesktop = this.deviceService.isDesktop();

    this.isMobile = this.deviceService.isMobile();

  }

  ngOnChanges(changes: SimpleChange) {

    if ($('input[name="optradio"]:checked').val() == 'option5') {

      this.getArea();

    }

  }

  ngOnInit(): void {

    // HubConnection status
    this._signalRService.isHubConnected$.pipe(takeUntil(this.destroy$)).subscribe((isConnect: boolean) => {

      this.isHubConnect = isConnect;

      this.registerHubListeners();

    });

    if (!this.isDesktop) this.close();

    this.comapnyName = this.gurdService.decrypt(window.localStorage.getItem('companyName')!);

    this.fullName = this.gurdService.decrypt(window.localStorage.getItem('FullName')!);

    var data = window.localStorage.getItem('menu') as any;

    this.acssess = JSON.parse(this.gurdService.decrypt(data));

    this.getGroup();

    $('#reporetArea').click(() => {

      this.reportWork();

    });

    // Go to Animate Area

    $('#enterAnimateArea').click(() => {
      $('#carMoveAreaModal').modal('hide');
      (window as any).open(`/route/${this.carId}/${this.GeoFence}`, '_blank').focus();
      window.localStorage.setItem('RouteDate', this.gurdService.encrypt(this.dataPolygans.value.date));
    });

    this.bOfficial = this.stateManagement.bOfficial;

    if (this.stateManagement.filterItem_Management.length > 0 || this.stateManagement.radioButton_Management != undefined || this.stateManagement.selectBox_Management != undefined) {

      if (this.stateManagement.selectBox_Management != undefined) this.carGroupModel = this.stateManagement.selectBox_Management

      this.filterItem = this.stateManagement.filterItem_Management;

      this.buildCarIndexMap();

      $(`#${this.stateManagement.radioButton_Management}`).attr('checked', true);

      $('#input_KeyValue').val(this.stateManagement.searchKey_Management);

      setTimeout(() => {

        this.carGroup.emit(this.filterItem);

      }, 700);

      this.onlineCar = this.filterItem.filter((el: any) => {

        return el.bOnline == true;

      });

      this.oflineCar = this.filterItem.filter((el: any) => {

        return el.bOnline == false;

      });

      this.noRecord = this.filterItem.filter((el: any) => {

        return el.bNoMobileHistory == true;

      });

    }

    else {

      const myInterval = setInterval(() => {

        if (this.item) {

          this.filterItem = this.item;

          this.buildCarIndexMap();

          this.onlineCar = this.item.filter((el: any) => {

            return el.bOnline == true;

          });

          this.oflineCar = this.item.filter((el: any) => {

            return el.bOnline == false;

          });

          this.noRecord = this.item.filter((el: any) => {

            return el.bNoMobileHistory == true;

          });

          clearInterval(myInterval);

        }

      }, 500);

    }

    setTimeout(() => {

      $('input[type=radio][name=optradio]').change((e: any) => {

        $('#carGroup').val('-1'); // نوع خودرو را به همه نوع خودرو تغییر بده

        $("#input_KeyValue").val(""); // Directly set the value

        if (e.target.value == 'option1') { // همه خودروها

          // اگر خودروهای اداری انتخاب شده بود

          if (this.bOfficial) {

            this.filterItem = this.item.filter((el: any) => {

              return el.bOfficial;

            });

          }

          // اگر همه خودروها انتخاب شده بود

          else {

            this.filterItem = this.item;

            this.filterList = this.filterItem;

          }

        }

        else if (e.target.value == 'option2') { // فعال

          // اگر خودروهای اداری انتخاب شده بود

          if (this.bOfficial) {

            this.filterItem = this.item.filter((el: any) => {

              return (el.bOfficial && (el.tiOfficialStatus == 1 || el.tiOfficialStatus == 2));

            });

            this.filterList = this.filterItem;

          }

          // اگر همه خودروها انتخاب شده بود

          else {

            this.filterItem = this.item.filter((el: any) => {

              return el.bOnline == true;

            });

            this.filterList = this.filterItem;

          }

        }

        else if (e.target.value == 'option3') { // غیر فعال

          // اگر خودروهای اداری انتخاب شده بود

          if (this.bOfficial) {

            this.filterItem = this.item.filter((el: any) => {

              return el.bOfficial && el.tiOfficialStatus == 0;

            });

            this.filterList = this.filterItem;

          }

          // اگر همه خودروها انتخاب شده بود

          else {

            this.filterItem = this.item.filter((el: any) => {

              return el.bOnline == false && el.bNoMobileHistory == false;

            });

            this.filterList = this.filterItem;

          }

        }

        else if (e.target.value == 'option4') { // 

          this.filterItem = this.item.filter((el: any) => {

            return el.bNoMobileHistory == true;

          });

          this.filterList = this.filterItem;

        }

        else if (e.target.value == 'option5') { // محدوده

          this.getArea();

        }

        this.carGroup.emit(this.filterItem);

        this.stateManagement.filterItem_Management = this.filterItem;

        this.stateManagement.radioButton_Management = e.currentTarget.id;

      });

    }, 600);

    var interval = setInterval(() => {

      if (this.item) {

        this.filterList = this.item;

        clearInterval(interval);

      }

    }, 500) as any;

    this.getCarLenght()

  };

  ngOnDestroy(): void {

    this.destroy$.next();
    this.destroy$.complete();

  }

  ngAfterViewInit(): void {
    $('[name="analysis"]').click((e: any) => {
      $('#modalPolygan').modal('hide');
      var tooltip = $('#map_tooltip');
      tooltip.tooltip('hide');
      $('#exampleModalreportArea').modal('show');

      if (e.target.id == "enterExit") {
        this.analysisId = 1;
      }
      if (e.target.id == "analysisArea") {
        this.analysisId = 2;
      }
    });

  }

  registerHubListeners() {

    if (this.hubHandlersBound) return;

    this.hubHandlersBound = true;

    this.ngZone.runOutsideAngular(() => {

      // when alarm triger
      this._signalRService.alarm$.pipe(takeUntil(this.destroy$)).subscribe((data: IAlarm) => {
        let res = JSON.parse(data.toString());
        this.updateAlarmFeed(res)
      });

      // when single car location updated
      this._signalRService.locationChanged$.pipe(takeUntil(this.destroy$)).subscribe((data: any) => {
        let res = JSON.parse(data.toString()) as ILocationChanged;
        this.bufferVehicleUpdates(res);
      });

      // when car's location updated
      this._signalRService.locationChangedBatch$.pipe(takeUntil(this.destroy$)).subscribe((data: any) => {
        let res = JSON.parse(data.toString()) as ILocationChanged[];
        this.bufferVehicleUpdates(res);
      });

    });

  };

  private bufferVehicleUpdates(updates: ILocationChanged | ILocationChanged[]) {

    if (Array.isArray(updates)) {
      for (const item of updates) {
        const updatedCarIndex = this.carIndexMap.get(item.strUnitID);

        if (updatedCarIndex !== undefined) {
          const tiStatus = item.tiDeviceStatus;
          const strStatus = tiStatus == 7 ? item.strDeviceEventsType_strComment : item.strDeviceStatus_strComment;

          this.blinkTableRow(updatedCarIndex, tiStatus);

          Object.assign(this.filterItem[updatedCarIndex], {
            fLon: item.fLon,
            fLat: item.fLat,
            iSpeed: item.iSpeed,
            siAngle: item.iAngle,
            strDate: item.strDate,
            strTime: item.strTime,
            strUnitId: item.strUnitID,
            tiDeviceStatus: tiStatus,
            strDeviceStatus_strComment: strStatus
          });
        }
      }
    }

    else {
      const updatedCarIndex = this.carIndexMap.get(updates.strUnitID);

      if (updatedCarIndex !== undefined) {
        const tiStatus = updates.tiDeviceStatus;
        const strStatus = tiStatus == 7 ? updates.strDeviceEventsType_strComment : updates.strDeviceStatus_strComment;

        this.blinkTableRow(updatedCarIndex, tiStatus);

        Object.assign(this.filterItem[updatedCarIndex], {
          fLon: updates.fLon,
          fLat: updates.fLat,
          iSpeed: updates.iSpeed,
          siAngle: updates.iAngle,
          strDate: updates.strDate,
          strTime: updates.strTime,
          strUnitId: updates.strUnitID,
          tiDeviceStatus: tiStatus,
          strDeviceStatus_strComment: strStatus
        });
      }
    }
  };

  private buildCarIndexMap() {

    this.carIndexMap.clear();

    this.filterItem.forEach((car, index) => {

      const unitId = this.getUnitId(car);

      if (!unitId) return;

      this.carIndexMap.set(unitId, index);

    })

  };

  private blinkTableRow(index: number, status: number) {
    const row = document.getElementById(`row${index}`) as HTMLTableRowElement;
    if (!row) {
      return;
    }

    if (this.filterItem && this.filterItem[index]) {
      const item = this.filterItem[index];
      this.filterItem.splice(index, 1);      
      this.filterItem.unshift(item);        
    }

    // const tbody = row.parentElement;
    // if (tbody && tbody.firstChild) {
    //   tbody.insertBefore(row, tbody.firstChild);
    // }

    const originalColor = getComputedStyle(row).backgroundColor;
    row.style.transition = 'background-color 0.5s ease';

    if (status != 7) {
      row.style.backgroundColor = '#8ce68c';
    } else {
      row.style.backgroundColor = '#FFCDD2';
    }

    setTimeout(() => {
      row.style.backgroundColor = originalColor;
    }, 900);
  }

  private getUnitId(item: any): string | null {
    const unitId = item?.strUnitID ?? item?.strUnitId;
    return unitId ? String(unitId) : null;
  }

  updateAlarmFeed(alarm: IAlarm) {

    this.alarms[this.alarmIndex] = alarm;

    this.alarmIndex = (this.alarmIndex + 1) % this.MAX_ALARMS; // بعدی برای نوشتن

    if (this.alarmCount < this.MAX_ALARMS) {

      this.alarmCount++;

    }

  }

  get visibleAlarms(): IAlarm[] {

    const result: IAlarm[] = [];

    for (let i = 0; i < this.alarmCount; i++) {

      const index = (this.alarmIndex - 1 - i + this.MAX_ALARMS) % this.MAX_ALARMS; // جدید ترین

      result.push(this.alarms[index]);

    }

    return result;

  }

  getCarLenght = async () => {
    var model = {
      strSession: `${this.gurdService.decrypt(localStorage.getItem('Session')!)}`,
      Id: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
      strUnitID: "",
    };
    const resp = await axios.post(`GetCarCount`, model);
    this.carNumber = resp.data;
    if (this.carNumber == -1) {
      // if (this.carNumber == 0) {
      $.confirm({
        title: `خودرویی برای شما ثبت نشده است آیا مایل به ثبت خودرو هستید؟
        `,
        content: '',
        type: 'blue',
        buttons: {
          ok: {
            text: "بله هستم",
            btnClass: 'btn-success',
            keys: ['enter'],
            action: async () => {
              $("#exampleModal").modal("show");
            }
          },
          cancel: {
            text: "خیر نیستم",

          }

        }
      });
      return;
    }
  }

  close() {

    let tag = document.getElementsByTagName('menu_car') as any;

    tag[0].classList.add('d-none');

    let bgTag = document.getElementById('bg-menu') as any;

    bgTag.classList.add('d-none');
  }

  exportexcel(): void {
    /* pass here the table id */
    let element = document.getElementById('excel-table');
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, this.fileName);
  }

  guid() {
    this.otherService.guid(34);
  }

  async select(index: any, item: any) {

    var rows = document.getElementsByName('rowTable');

    var row = document.getElementById(`row${index}`) as any;

    for (let i = 0; i < rows.length; i++) {

      rows[i].classList.remove('bg-gray');

    }

    row.classList.add('bg-gray');

    // دریافت موقعیت جدید خودرو

    this.otherService.Showspinner()

    var model = {
      ID: this.gurdService.decrypt(localStorage.getItem('ID')!),
      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),
      strUnitID: item.strUnitID ?? item.strUnitId
    };

    const resp = await axios.post(`GetCar?strUnitID=${model.strUnitID}`, model);

    this.otherService.nonespinner();

    if (resp.data.ISSessionExpired == true) {

      this.otherService.removeLocalStorage();

      // this.router.navigate(['login']);

      this.router.navigate(['login'], { queryParams: { error: '112' } });


      return;

    }

    if (resp.data == null) {

      this.notifyService.showError('بروز خطا در سامانه');

      return;

    }

    let updated_Data = resp.data;

    updated_Data.strIconName = item.strIconName;

    this.filterItem[index].strDate = updated_Data.strDate;

    this.filterItem[index].strTime = updated_Data.strTime;

    this.locationTable.emit({ item: updated_Data, index });

    this.carIdOut.emit(item.strUnitID);

    if (this.isMobile) this.close();

  }

  openDetailPage(id: any) {
    this.stateManagement.filterItem_Management = this.filterItem;
    this.router.navigate([`carInfo/${id}`]);
    var tooltip = $('#map_tooltip');
    tooltip.tooltip('hide');

  }

  openVehicleInfo(alarm: IAlarm) {
    const vehicleUrl = this.router.createUrlTree(['/carInfo', String(alarm.strUnitID).trim()])

    const url = this.router.serializeUrl(vehicleUrl);
    window.open(url, '_blank');
    var tooltip = $('#map_tooltip');
    tooltip.tooltip('hide');

  }

  search(val: any) {

    if (this.bOfficial) {

      // console.log(this.filterItem) // فیلتر اعمال شده بر روی دکمه های بالایی

      // console.log(this.filterList) // لیست کلی

      if ($('input[type=radio]').val() == 'option1' && this.filterList == null) {

        this.filterItem = this.item.filter((el: any) => {

          return el.bOfficial;

        });

      }

      this.filterItem = this.filterList.filter((el: any) => {

        return el.bOfficial && (el.strFullName2.includes(val.value) || el.strVehicleNo.includes(val.value));

      });

      this.stateManagement.filterItem_Management = this.filterItem;

      this.stateManagement.searchKey_Management = val.value;

      this.carGroup.emit(this.filterItem);

    }

    else {

      if ($('input[type=radio]').val() == 'option1' && this.filterList == null) {

        this.filterList = this.filterList;

      }

      this.filterItem = this.filterList.filter((el: any) => {

        return el.strFullName.includes(val.value) ||

          el.strFullName2.includes(val.value) ||

          el.strVehicleNo.includes(val.value);

      });

      this.stateManagement.filterItem_Management = this.filterItem;

      this.stateManagement.searchKey_Management = val.value;

      this.carGroup.emit(this.filterItem);

    }

  }

  viewSubDetails(i: any) {
    let toggle = document.getElementById(`collapsible${i}`);
    toggle?.classList.toggle('show')
  }

  getArea = async () => {

    var model = this.otherService.stringNumberToNumber({

      strSession: `${this.gurdService.decrypt(localStorage.getItem('Session')!)}`,

      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),

      iGeoFence: this.GeoFence,

      bOfficial: this.bOfficial

    })

    const resp = await axios.post(`Radyab_GetMobileInGeoFence`, model);

    this.filterItem = resp.data;

    this.filterList = this.filterItem;

    this.carGroup.emit(this.filterItem);

  };

  getGroup = async () => {
    const resp = await axios.post(`GetMobileType`, {});
    this.groupCar = resp.data;
  };

  carGroupChange(val: any) {

    if (this.bOfficial) {

      if (val.value == '-1') {

        this.filterItem = this.filterList.filter((el: any) => {

          return el.bOfficial;

        });

      }

      else {

        this.filterItem = this.filterList.filter((el: any) => {

          return el.bOfficial && (el.tiMobileType == val.value);

        });

      }

      this.carGroup.emit(this.filterItem);

      this.stateManagement.filterItem_Management = this.filterItem;

      this.stateManagement.selectBox_Management = val.value;


    }

    else {

      if (val.value == '-1') this.filterItem = this.filterList;

      else {

        this.filterItem = this.filterList.filter((el: any) => {

          return el.tiMobileType == val.value;

        });

      }

      this.carGroup.emit(this.filterItem);

      this.stateManagement.filterItem_Management = this.filterItem;

      this.stateManagement.selectBox_Management = val.value;

    }

  }

  showOfficialCar(type: number) {

    this.isAlarmFeed = false;

    // همه خودرو ها

    if (type == -1) {

      this.filterItem = this.item;

      this.filterList = this.filterItem;

      this.bOfficial = false;

      this.stateManagement.bOfficial = false;

      $('input[type=radio][name=optradio]#radio1').prop('checked', true);

      $("#carGroup").val("-1"); // Directly set the value

      $("#input_KeyValue").val(""); // Directly set the value

    }

    // خودروهای اداری

    else {

      this.filterItem = this.item.filter((el: any) => {

        return el.bOfficial;

      });

      this.filterList = this.filterItem;

      this.bOfficial = true;

      this.stateManagement.bOfficial = true;

      $('input[type=radio][name=optradio]#radio1').prop('checked', true);

      $("#carGroup").val("-1"); // Directly set the value

      $("#input_KeyValue").val(""); // Directly set the value

    }

    this.carGroup.emit(this.filterItem);

  }

  onAlarmFeed() {

    this.showOfficialCar(-1);

    this.isAlarmFeed = !this.isAlarmFeed;

  }

  openpolyganModal(item: any) {

    if (this.GeoFence != '-1') {

      $('#modalPolygan').modal('show');

      this.carId = item?.strUnitId ? item.strUnitId : item.strUnitID;

      this.carIdOut.emit({ strUnitId: this.carId, ...item });

      // this.carIdOut.emit(item?.strUnitId ? item.strUnitId : item.strUnitID);

    }

    else {

      this.notifyService.showInfo(

        'برای استفاده از این قابلیت ابتدا محدوده را مشخص کنید',

        'توجه'

      );

    }

  }

  reportWork() {
    var Stime = document.getElementById('clocks') as any;
    var Etime = document.getElementById('clocke') as any;
    window.localStorage.setItem('reportDataZa', this.gurdService.encrypt(this.dataWorkAz.value.date));
    window.localStorage.setItem('reportDataTa', this.gurdService.encrypt(this.dataWorkTa.value.date));
    window.localStorage.setItem('reportStime', this.gurdService.encrypt(Stime.value));
    window.localStorage.setItem('reportEtime', this.gurdService.encrypt(Etime.value));
    $('#exampleModalreportArea').modal('hide');
    if (this.analysisId == 2) {
      this.router.navigate([`report/${this.carId}/10/${this.GeoFence}`]);
    }
    if (this.analysisId == 1) {
      this.router.navigate([`report/${this.carId}/11/${this.GeoFence}`]);
    }
  }

  sortByName() {

    this.filterItem.sort((a: any, b: any) => {

      var textA = a.strFullName.toUpperCase();

      var textB = b.strFullName.toUpperCase();

      // return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;

      if (textA > textB)
        return (textA < textB) ? 1 : (textA > textB) ? -1 : 0;
      if (textA < textB)
        return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
      return

    });

  }

  sortByStatus() {

    this.filterItem.sort((a: any, b: any) => {

      var textA = a.tiDeviceStatus;

      var textB = b.tiDeviceStatus;

      // return (textA > textB) ? -1 : (textA < textB) ? 1 : 0;

      if (textA > textB)
        return (textA < textB) ? 1 : (textA > textB) ? -1 : 0;
      if (textA < textB)
        return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
      return

    });

  }

  sortByDate() {

    this.filterItem.sort((a: any, b: any) => {

      var textA = a.strDate;

      var textB = b.strDate;

      // return (new Date(textA) as any) - (new Date(textB) as any);

      if (new Date(textA) > (new Date(textB)))
        return (new Date(textA) < (new Date(textB))) ? 1 : (new Date(textA) > (new Date(textB))) ? -1 : 0;
      if (new Date(textA) < (new Date(textB)))
        return (new Date(textA) < (new Date(textB))) ? -1 : (new Date(textA) > (new Date(textB))) ? 1 : 0;
      return

    });

  }

  focusOnCurrentLocation(alarm: IAlarm, index = -1) {

    this.locationTable.emit({ item: alarm, index, type: 'alarm' });

  }

}
